export var DisclaimerTypes;
(function (DisclaimerTypes) {
    DisclaimerTypes["INDICATIVE_INTEREST_RATE"] = "indicative_interest_rate";
    DisclaimerTypes["COMPARISON_RATE"] = "comparison_rate";
    DisclaimerTypes["GFV"] = "gfv";
    DisclaimerTypes["DEALER_REPAYMENT"] = "dealer_repayment";
    DisclaimerTypes["DISTRIBUTOR_REPAYMENT"] = "distributor_repayment";
    DisclaimerTypes["REPAYMENT"] = "Repayment";
    DisclaimerTypes["DEALER_PRICE"] = "dealer_price";
    DisclaimerTypes["DISTRIBUTOR_PRICE"] = "distributor_price";
    DisclaimerTypes["ACCESSORIES"] = "accessories";
    DisclaimerTypes["SERVICE_PLANS"] = "service_plan";
    DisclaimerTypes["COLOURS"] = "colours";
})(DisclaimerTypes || (DisclaimerTypes = {}));
//# sourceMappingURL=DisclaimerTypes.js.map